<div class="container-dropdown">
  <ion-item lines="none"  detail="false">     
    <ion-select
      label="{{floatingLabel}}" 
      label-placement="floating"
      fill="outline"
      interface="popover"
      [interfaceOptions]="{ cssClass: classesForPopover, Size: 'cover', alignment:'start' }"
      (ionChange)="onSelectChange($event)"
      [value]="selectedValue"
      toggleIcon="chevron-down"
    >
      <ion-select-option
        class=""
        *ngFor="let option of options"
        [value]="option.value"
        >{{ option.value }}</ion-select-option
      >
     
    </ion-select>
    
  </ion-item>
</div>

